import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useShopContext } from '../../context/ShopContext';
import { useProductContext } from '../../context/ProductContext';
import LoadingSpinner from '../../components/utils/LoadingSpinner';
import Alert from '../../components/utils/Alert';
import ProductCard from '../../components/common/ProductCard';
import FeaturedProductsSection from '../../components/sections/FeaturedProductsSection';

export default function ProductsPage() {
  const { t } = useTranslation();
  const { selectedBranch, loading: shopLoading, error: shopError } = useShopContext();
  const {
    products,
    loading: productLoading,
    error: productError,
    fetchProducts,
    fetchProduct,
  } = useProductContext();

  const [searchParams, setSearchParams] = useSearchParams();
  const [searchTerm, setSearchTerm] = useState(searchParams.get('search') || '');
  // const navigate = useNavigate();
  // const { id, branchID, category ,store} = useParams();

  useEffect(() => {
    const newParams = new URLSearchParams(searchParams);


    fetchProducts(newParams);
  }, [searchParams, selectedBranch]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const newParams = new URLSearchParams(searchParams);
    if (searchTerm) {
      newParams.set('search', searchTerm);
    } else {
      newParams.delete('search');
    }
    setSearchParams(newParams);
  };

  if (shopError || productError) {
    return (
      <div className="container mx-auto px-6 py-12">
        <Alert type="error" message={t('products.error')} />
      </div>
    );
  }

  return (
    <div className="container mx-auto px-6 py-12">
      <h1 className="text-3xl font-heading font-bold mb-8">{t('products.title')}</h1>



           <FeaturedProductsSection />
     
    </div>
  );
}
